var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRegisterHiddenEye = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m11.768 6.197 3.399-3.456 1.24 1.262L3.071 17.564l-1.24-1.262 4.688-4.767a3.8 3.8 0 0 1-.116-.95c0-.893.264-1.606.702-2.23-1.228.445-2.456 1.159-3.42 2.14l-2.457 2.498L0 11.744l2.456-2.498c2.496-2.617 6.031-3.612 9.312-3.049m-3.435 7.51c.527.267 1.053.445 1.667.445 1.93 0 3.597-1.605 3.597-3.657 0-.624-.176-1.16-.439-1.695zm6.404-6.512c1.052.535 1.93 1.16 2.807 2.051L20 11.744l-1.228 1.249-2.456-2.498a8.8 8.8 0 0 0-2.895-1.962z",
  clipRule: "evenodd"
})));
export default SvgRegisterHiddenEye;